<template>
  <div>
    <!-- 筛选项 -->
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit" width="110px" :mdSpan="6" :flexFlag="true">
      <div class="component_title2">筛选项</div>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="投诉单创建时间">
          <dataPicker :clearFlag="true" :datevalue.sync="searchForm.gmt_create"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="投诉单结束时间">
          <dataPicker :clearFlag="true" :datevalue.sync="searchForm.gmt_finished"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="应用">
          <SelectCustomize :value="searchForm.appid" :data="apps" />
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="6" :sm="24">
        <el-form-item label="归因渠道" prop="channel">
          <el-input placeholder="请输入归因渠道" v-model="searchForm.channel">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="投诉类别">
          <el-select v-model="searchForm.type" placeholder="请选择">
            <el-option v-for="item in complaintOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="投诉状态">
          <SelectCustomize :value="searchForm.status" :data="stateOptions" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="平台投诉单号">
          <el-input type="textarea" :rows="1" placeholder="多个单号请用逗号分隔" v-model="searchForm.complain_event_id">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="我方交易单号">
          <el-input placeholder="请输入我方交易单号" v-model="searchForm.ostr">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="投诉人手机号">
          <el-input placeholder="请输入投诉人手机号" v-model.trim="searchForm.phone_no">
          </el-input>
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>
    <!-- 数据报表 -->
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableOpt.currentPage" :leadOut="true" :params="outPamrms" alignStyle="center"
      leadApi="complain/list" @pageChange="onPageChange" @sizeChange="onSizeChange" @handleChange="handleChange"
      @sortChange="onSortChange" selection="selection" :rowKey="tableIds" ref="multipleTable" :keyFlag="false"
      author="liuqiang" :rowStyle="{
        'max-height': '50px',
      }">
      <template slot="table-option">
        <el-popconfirm title="确定批量退款所选投诉单？" @confirm="allBack">
          <el-button type="danger" slot="reference">
            批量退款
            <el-tooltip class="item" effect="dark" content="只能针对投诉状态为“待处理/客户处理中”，并且只包含了一条平台交易单的投诉单，进行批量退款，其他投诉单请单条处理"
              placement="top-start">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </el-button>
        </el-popconfirm>
        <el-popconfirm title="否确认将所选投诉单状态改为“投诉完结”" @confirm="forceOver">
          <el-button style="margin-left: 10px" type="danger" slot="reference" v-show="indexFlag !== -1">强制完结</el-button>
        </el-popconfirm>
      </template>
      <template #channel="{ row }">
        <div>
          {{ row.channel ? row.channel : "-" }}
        </div>
      </template>
      <!-- 投诉类别 -->
      <template #app_str="{ row }">
        <div>
          <span v-if="row.app_str">{{ row.app_str }}</span>
          <span v-else style="color: red">未关联中台应用请联系中台人员</span>
        </div>
      </template>
      <!-- 投诉类别 -->
      <template #type="{ row }">
        <div>
          {{ row.type == 1 ? "小程序与代扣等投诉" : "支付交易投诉" }}
        </div>
      </template>
      <!-- 平台交易号 -->
      <template #trade_no="{ row }">
        <el-popover placement="right" width="250" trigger="hover">
          <div>
            <div v-for="(item, index) in row.trade_no" :key="index">
              {{ item }}
            </div>
          </div>
          <span slot="reference">{{ row.trade_no[0] }}</span>
        </el-popover>
      </template>
      <!-- 我方投诉单号 -->
      <template #ostr="{ row }">
        <el-popover placement="right" width="250" trigger="hover">
          <div>
            <div v-for="(item, index) in row.order_info" :key="index" style="padding: 5px 0" v-if="row.order_info">
              {{ item.ostr }}
              <el-tag type="success" size="small" v-if="item.is_refund === false">退款失败</el-tag>
              <el-tag type="danger" size="small" v-else-if="item.is_refund === true">已退款</el-tag>
              <el-tag type="warning" size="small" v-else>未退款</el-tag>
            </div>
            <div v-if="!row.order_info">
              {{ row.ostr[0] }}
            </div>
          </div>
          <span slot="reference">{{ row.ostr[0] }}</span>
        </el-popover>
      </template>
      <!-- 投诉单开始时间 -->
      <template #gmt_create="{ row }">
        <div>
          {{ moment(row.gmt_create * 1000).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </template>
      <!-- 订单创建时间 -->
      <template #create_time="{ row }">
        <div>
          {{
            row.create_time != 0
              ? moment(row.create_time * 1000).format("YYYY-MM-DD HH:mm:ss")
              : "-"
          }}
        </div>
      </template>
      <!-- 投诉单结束时间 -->
      <template #gmt_finished="{ row }">
        <div>
          {{
            row.gmt_finished > 0
              ? moment(row.gmt_finished * 1000).format("YYYY-MM-DD HH:mm:ss")
              : "-"
          }}
        </div>
      </template>
      <!-- 投诉状态 -->
      <template #status="{ row }">
        <div>
          <span v-if="row.status == 1" style="color: #f90000">待处理</span>
          <span v-if="row.status == 2" style="color: #1add20">已退款未修改</span>
          <span v-if="row.status == 3" style="color: #1add20">投诉完结</span>
          <span v-if="row.status == 4" style="color: #1add20">已处理</span>
          <span v-if="row.status == 8" style="color: #1add20">投诉关闭</span>
          <span v-if="row.status == 5" style="color: #f90000">客服处理中</span>
          <span v-if="row.status == 6" style="color: #1add20">客服处理完结</span>
          <span v-if="row.status == 7" style="color: #f90000">客服处理中</span>
          <el-popover placement="top-start" width="200" trigger="hover" :content="row.error"
            v-show="row.error && row.error !== null" title="失败反馈">
            <span slot="reference" class="el-icon-warning-outline" v-show="row.error" style="
                padding-left: 5px;
                position: absolute;
                right: 10px;
                top: 4px;
              "></span>
          </el-popover>

          <el-popover placement="top-start" width="200" trigger="hover" content="有一部分交易单处理失败，请前往支付平台处理"
            v-show="row.status == 5" title="提示">
            <span slot="reference" class="el-icon-warning-outline" v-show="row.status == 5" style="
                padding-left: 5px;
                position: absolute;
                right: 10px;
                top: 4px;
              "></span>
          </el-popover>
        </div>
      </template>
      <!-- 投诉金额 -->
      <template #amount="{ row }">
        <div>
          {{ row.amount ? row.amount : "-" }}
        </div>
      </template>
      <!-- 图片 -->
      <template #images="{ row }">
        <div>
          <el-image v-if="row.images && row.images.length" style="width: 50px; height: 50px"
            :src="row.images[0] ? row.images[0] : ''" :preview-src-list="row.images ? row.images : []">
          </el-image>
        </div>
      </template>
      <!-- 电话号码 -->
      <template #phone_no="{ row }">
        <div>
          <el-popover placement="right" width="80" trigger="hover" v-if="row.phone_no.length > 1">
            <div v-for="(item, index) in row.phone_no" :key="index">
              <span v-if="item.appid === row.appid">{{ item.phone }}</span>
              <span style="color: #f90000" v-else>{{ item.phone }}</span>
            </div>
            <span slot="reference">{{ row.phone_no[0].phone }}</span>
          </el-popover>
          <span v-else>
            <span style="color: #f90000" v-if="row.phone_no_flag || (!row.app_str && row.phone_no[0].length)
            ">
              {{ row.phone_no.length ? row.phone_no[0].phone : "" }}
            </span>
            <span v-else>
              {{ row.phone_no.length ? row.phone_no[0].phone : "" }}
            </span>
          </span>
          <el-popover placement="top-start" width="200" trigger="hover" v-show="row.phone_no_flag || (!row.app_str && row.phone_no[0].length)
            ">
            <span style="color: #f90000">红色为非本应用手机号,注意沟通话述</span>
            <span style="padding-left: 5px" slot="reference" class="el-icon-warning-outline"
              v-show="row.phone_no_flag"></span>
          </el-popover>
        </div>
      </template>
      <!-- 操作 -->
      <template #option="{ row }">
        <!-- <el-popover
          placement="top"
          width="150"
          v-model="visible"
          
          :ref="`popover-${row.id}`"
        >
          <p>确定退款此条投诉单？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="visible = false"
              >取消</el-button
            >
            <el-button type="primary" size="mini" @click="openDialog()"
              >确定</el-button
            >
          </div>
          <el-button slot="reference" type="text">退款1 popover+{{row.id}}</el-button>
        </el-popover> -->
        <el-popover placement="left" trigger="click" v-show="row.status == 1 ||
          (row.status == 7 && row.ostr.length == row.trade_no.length)
          " @confirm="openDialog([row.id])" v-model="row.visible" :ref="`popover-${row.id}`" :key="`Popover-${row.id}`"
          @show="showPopover(row.id)">
          <div style="font-size: 12px">
            {{
              row.order_info && row.order_info.length
                ? "请选择所需处理订单"
                : "确定退款此条投诉单？"
            }}
            <span v-if="row.order_info && row.order_info.length" style="color: #f90000">投诉单处理只能发起一次，谨慎选择</span>
          </div>
          <el-table @selection-change="handleSelectionChange" height="300px" :data="row.order_info"
            :default-sort="{ prop: 'pay_time', order: 'descending' }" v-if="row.order_info && row.order_info.length"
            ref="myTable">
            <el-table-column type="selection" :reserve-selection="true" fixed>
            </el-table-column>
            <el-table-column width="160" prop="ostr" label="我方交易单号"></el-table-column>
            <el-table-column width="180" prop="pay_time" label="支付时间" sortable>
              <template slot-scope="scope">
                {{
                  moment(scope.row.pay_time * 1000).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                }}
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin: 10px 0 0 0">
            <el-button size="mini" type="text" @click="row.visible = false">取消</el-button>
            <el-button type="primary" size="mini" @click="openDialog([row.id])">确定</el-button>
          </div>
          <el-button size="small" type="primary" @click.stop.propagation slot="reference">退款</el-button>
        </el-popover>
        <!-- <el-popover
          placement="top"
          width="160"
          v-model="overVisible"
          :ref="row.id"
          v-show="row.status == 2"
        >
          <p>确定完结此条投诉单？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="overVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="mini" @click="openDialog()"
              >确定</el-button
            >
          </div>
          <el-button slot="reference" type="text">投诉完结</el-button>
        </el-popover> -->
        <el-popconfirm title="确定完结此条投诉单？" @confirm="openDialog([row.id])"
          v-show="row.status == 2 && row.ostr.length == row.trade_no.length">
          <el-button style="margin-left: 8px" size="small" type="primary" slot="reference">投诉完结</el-button>
        </el-popconfirm>

        <span v-if="row.ostr.length != row.trade_no.length" style="color: #f90000">
          此投诉单信息不全，请前往支付平台处理，处理后请告知中台人员
        </span>
        <!-- <el-popover
          placement="top-start"
          trigger="click"
          v-show="row.status == 2"
          @confirm="openDialog([row.id])"
          v-model="row.visible"
          :ref="`popover-${row.id}`"
        >
          <div style="font-size:12px">
            {{row.order_info && row.order_info.length?'选择要完结的我方交易号':'确定完结此条投诉单？'}}
          </div>
          <el-table @selection-change="handleSelectionChange" height="300px" :data="row.order_info" v-if="row.order_info && row.order_info.length">
            <el-table-column type="selection" :reserve-selection="true" fixed>
            </el-table-column>
            <el-table-column
              width="200"
              prop="ostr"
              label="我方交易单号"
            ></el-table-column>
          </el-table>
          <div style="text-align: right; margin: 10px 0 0 0">
            <el-button size="mini" type="text" @click="row.visible = false"
              >取消</el-button
            >
            <el-button type="primary" size="mini" @click="row.visible = false"
              >确定</el-button
            >
          </div>
          <el-button type="primary" @click.stop.propagation slot="reference"
            >投诉完结</el-button
          >
        </el-popover> -->
      </template>
    </TableLayout>

    <el-dialog :title="loading
      ? '请勿刷新或关闭页面'
      : !loading && !errArr.length
        ? '处理成功'
        : !loading && errArr.length
          ? '处理失败'
          : ''
      " :custom-class="loading
        ? 'err_tit_dialog'
        : !loading && !errArr.length
          ? 'sur_tit_dialog'
          : !loading && errArr.length
            ? 'err_tit_dialog'
            : ''
        " :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="!loading && errArr.length" @closed="downDia" center>
      <div class="dialog_box">
        <!-- 列表页面 -->

        <!-- loading页面 -->
        <div v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="处理中"
          class="flex_j_content" v-if="loading" style="padding: 50px 0 50px 0"></div>
        <!-- 成功的展示页面 -->
        <div v-if="!loading && !errArr.length" style="text-align: center">
          <div><img src="./img/chenggong.svg" alt="" class="imgClass" /></div>
          <div class="btn_box">处理成功页面将在几秒后关闭</div>
        </div>
        <!-- 失败的展示页面 -->
        <div v-if="!loading && errArr.length">
          <div class="err_title">
            请针对以下投诉单再次发起退款或者投诉完结处理，如果多次失败请联系中台人员
          </div>
          <div style="margin: 10px 0">失败投诉单号如下：</div>
          <!-- 失败列表 -->
          <el-scrollbar class="err_srcoll_box">
            <div v-for="(item, index) in errArr" :key="index" style="padding-left: 10px">
              {{ item }}
            </div>
          </el-scrollbar>
          <div class="btn_list">
            <el-button type="primary" size="mini" @click="copyList">一键复制</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { goNewSys } from '@/util/index'
import moment from "moment";
import store from "store2";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import TransferDialog from "@/layout/transferDialog";
import SelectCustomize from "@/component/select-customize";
export default {
  components: {
    FilterLayout,
    SelectCustomize,
    TableLayout,
    TransferDialog,
  },
  data() {
    return {
      // 表格的筛选项
      searchForm: {
        gmt_create: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ],
        gmt_finished: [],
        appid: {
          appInfo: [],
        },
        channel: "",//归因渠道
        type: "1", //投诉类别
        status: {
          appInfo: [],
        }, //投诉状态
        complain_event_id: [], //平台投诉单号
        ostr: "", //我方交易单号
        phone_no: "", //投诉人手机号
      },
      // 表格排序
      sort: {
        prop: "",
        order: "",
      },
      // 表格数据
      tableData: {
        data: [], //数据
        total: 0, //总页数
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
        loading: false, //加载标杆
      },
      apps: [], //应用列表
      complaintOptions: [
        /* {
          value: "",
          label: "全选",
        }, */
        {
          value: "1",
          label: "小程序代扣等投诉",
        },
        /* {
          value: "2",
          label: "支付交易投诉",
        }, */
      ], //投诉类别
      stateOptions: [
        {
          id: "1",
          title: "待处理",
        },
        {
          id: "7",
          title: "客服处理中",
        },
        {
          id: "2",
          title: "已退款未修改",
        },
        {
          id: "4",
          title: "已处理",
        },
        {
          id: "8",
          title: "投诉关闭",
        },
        {
          id: "3",
          title: "投诉完结",
        },
        {
          id: "6",
          title: "客服处理完结",
        },
      ], //投诉状态
      column: [
        {
          label: "中台应用",
          prop: "app_str",
          width: "150",
          tooltipFlag: true,
        },
        {
          label: "归因渠道",
          prop: "channel",
          width: "100",
          tooltipFlag: true,
        },
        {
          label: "商户号",
          prop: "target_id",
          width: "150",
          tooltipFlag: true,
        },
        {
          label: "开发者APPID",
          prop: "dev_appid",
          tooltipFlag: true,
        },
        {
          label: "投诉类别",
          prop: "type",
          width: "150",
          tooltipFlag: true,
        },
        {
          label: "平台投诉单号",
          prop: "complain_event_id",
          width: "150",
          tooltipFlag: true,
        },
        {
          label: "平台交易号",
          prop: "trade_no",
          width: "150",
        },
        {
          label: "我方交易号",
          prop: "ostr",
          width: "150",
        },
        {
          label: "订单创建时间",
          prop: "create_time",
          sortable: "custom",
          tooltipFlag: true,
        },
        {
          label: "投诉单创建时间",
          prop: "gmt_create",
          sortable: "custom",
          tooltipFlag: true,
        },
        {
          label: "投诉单结束时间",
          prop: "gmt_finished",
          sortable: "custom",
          tooltipFlag: true,
        },
        {
          label: "投诉状态",
          prop: "status",
          tooltipFlag: true,
        },
        {
          label: "投诉诉求",
          prop: "leaf_category_name",
          tooltipFlag: true,
        },
        {
          label: "投诉原因",
          prop: "complain_reason",
          width: "130",
          tooltipFlag: true,
        },
        {
          label: "投诉内容",
          prop: "content",
          width: "150",
          tooltipFlag: true,
        },
        {
          label: "投诉图片",
          prop: "images",
        },
        {
          label: "金额(元)",
          prop: "amount",
          tooltipFlag: true,
        },
        {
          label: "用户姓名",
          prop: "user_name",
          tooltipFlag: true,
        },
        {
          label: "投诉人电话号码",
          prop: "phone_no",
          tooltipFlag: true,
        },
        {
          label: "操作",
          prop: "option",
          width: "120",
          tooltipFlag: true,
        },
      ], //表头
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      overVisible: false, //操作按钮
      dialogVisible: false, //蒙版
      loading: true, //加载
      outime: 3, //倒计时
      moment: moment, //时间实例
      errArr: [], //错误列表
      tableIds: [], //Ids,
      selectAll: [], //多选数据状态
      tableRow: [], //多选
      trade_no_list: [], //操作列表所选订单
      indexFlag: -1, //按钮权限控制
    };
  },
  computed: {
    outPamrms() {
      const { searchForm, sort, tableOpt } = this;
      let obj = {
        gmt_create: {
          start_date: searchForm.gmt_create.length
            ? searchForm.gmt_create[0]
            : "",
          end_date: searchForm.gmt_create.length
            ? searchForm.gmt_create[1]
            : "",
        },
        gmt_finished: {
          start_date: searchForm.gmt_finished.length
            ? searchForm.gmt_finished[0]
            : "",
          end_date: searchForm.gmt_finished.length
            ? searchForm.gmt_finished[1]
            : "",
        },
        appid:
          searchForm["appid"].appInfo.length === this.apps.length ||
            searchForm["appid"].appInfo.length === 0
            ? []
            : searchForm["appid"].appInfo,
        type: searchForm.type,
        status: searchForm["status"].appInfo,
        complain_event_id: searchForm.complain_event_id.length
          ? this.changeTextarea(searchForm.complain_event_id)
          : [],
        channel: searchForm.channel,
        ostr: searchForm.ostr,
        phone_no: searchForm.phone_no,
        field: sort.prop,
        order: sort.order,
        currentPage: 1,
        leadeOutType: "complaint",
      };
      return obj;
    },
  },
  created() {
    this.logDeveloper({
      web: "赵任杰",
      back: "刘强",
    });
  },
  mounted() {
    goNewSys({
      path: "/business/subsidiary_management/transaction_handling",
      target: "_self"
    })
    /* // 获取用户ID判断权限
    let flag =
      store.get("user")["id"] == "1" ||
      store.get("user")["id"] == "161" ||
      store.get("user")["id"] == "156" ||
      store.get("user")["id"] == "291" ||
      store.get("user")["id"] == "304" ||
      store.get("user")["id"] == "40";
    if (!flag) {
      this.complaintOptions = [
        {
          value: "1",
          label: "小程序代扣等投诉",
        },
      ];
      this.searchForm.type = "1";
    } */
    // 初始化调用事业群分组
    this.getRoleBtree();
    //调用列表
    this.getReport();
    // 调用权限列表
    let arr = store.get("menu");
    this.indexFlag = arr.indexOf("155");
  },
  methods: {
    // 获取筛选项表单数据
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree", {
        loginId: store.get("user")["id"],
        loginToken: store.get("loginToken"),
      });
      if (err) return;
      this.department_id = res.tree;
      let apps = [];
      let article_id_arr = [];
      res.list.forEach((item) => {
        if (item.title == "项目") {
          article_id_arr = item.node;
        }
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
          apps = item.node;
        }
      });
      this.apps_default = apps;
      this.apps = apps;
    },
    // 格式化请求参数
    formatSearch(name) {
      let data = this.searchForm[name].appInfo.join()
        ? this.searchForm[name].appInfo.join()
        : undefined;
      return data;
    },
    // 文本域的数据处理
    changeTextarea(data) {
      let result = data.split(/[\n,，\r\n]/);
      return result;
    },
    // 表单查询
    onSubmit() {
      this.tableOpt.currentPage = 1;
      this.$refs.multipleTable.$refs.table.clearSelection();
      this.getReport();
    },
    // 重置表单
    initFrom() {
      this.searchForm = {
        gmt_create: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ],
        gmt_finished: [],
        appid: {
          appInfo: [],
        },
        channel: "",
        type: "1", //投诉类别
        status: {
          appInfo: [],
        }, //投诉状态
        complain_event_id: [], //平台投诉单号
        ostr: "", //我方交易单号
        phone_no: "", //投诉人手机号
      };
      this.sort = {
        prop: "",
        order: "",
      };
      this.tableOpt.currentPage = 1;
      /* let flag =
        store.get("user")["id"] == "1" ||
        store.get("user")["id"] == "161" ||
        store.get("user")["id"] == "156" ||
        store.get("user")["id"] == "291" ||
        store.get("user")["id"] == "304" ||
        store.get("user")["id"] == "40";
      if (flag) {
        this.complaintOptions = [
          {
            value: "1",
            label: "小程序代扣等投诉",
          },
        ];
        this.searchForm.type = "1";
      } */
      this.getReport();
    },
    // 每页改变回调
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.getReport();
    },
    // 每页条数改变回调
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.getReport();
    },
    // 获取表格多选数据
    handleChange(data) {
      this.tableIds = data.map((item) => {
        return item.id;
      });
      this.selectAll = data.map((item) => {
        return item.status;
      });

      this.tableRow = data;
    },
    // 获取自定义字段
    async getParamDetail() {
      const [err, res] = await this.$http.post("Business/paramDetail", {
        cate: 1,
        timeStart: this.searchForm["time"][0],
        timeEnd: this.searchForm["time"][1],
      });
      if (err) return;
      res.showField.forEach((item) => {
        item.isSelect = false;
      });
      res.hiddenField.forEach((item) => {
        item.isSelect = false;
      });
      this.paramDetailData = res;
    },
    // 获取表格数据的接口函数
    async getReport() {
      // 格式化 this.formatSearch("appid") this.changeTextarea(this.searchForm.complain_event_id)
      const { searchForm, tableOpt, sort } = this;
      this.tableData.loading = true;
      const [err, res] = await this.$http.post("complain/list", {
        gmt_create: {
          start_date: searchForm.gmt_create.length
            ? searchForm.gmt_create[0]
            : "",
          end_date: searchForm.gmt_create.length
            ? searchForm.gmt_create[1]
            : "",
        },
        gmt_finished: {
          start_date: searchForm.gmt_finished.length
            ? searchForm.gmt_finished[0]
            : "",
          end_date: searchForm.gmt_finished.length
            ? searchForm.gmt_finished[1]
            : "",
        },
        appid:
          searchForm["appid"].appInfo.length === this.apps.length ||
            searchForm["appid"].appInfo.length === 0
            ? []
            : searchForm["appid"].appInfo,
        type: searchForm.type,
        status: searchForm["status"].appInfo,
        complain_event_id: searchForm.complain_event_id.length
          ? this.changeTextarea(searchForm.complain_event_id)
          : [],
        channel: searchForm.channel,
        ostr: searchForm.ostr,
        phone_no: searchForm.phone_no,
        ...tableOpt,
        field: sort.prop,
        order: sort.order,
      });
      this.tableData.loading = false;
      if (err || res.list === null) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          loading: false,
        };
        return;
      }
      let arr = [];
      res.list.forEach((item) => {
        item.phone_no.forEach((_item) => {
          if (_item.appid !== item.appid) {
            item.phone_no_flag = true;
          }
        });
        if (item.phone_no.length == 0) {
          item.phone_no_flag = false;
        }
        item.visible = false;
      });
      this.tableData.data = res.list;
      this.tableData.total = res.total;
    },
    // 表格排序
    onSortChange(data) {
      const { prop } = data;
      let order = data.order;
      if (order === "ascending") {
        this.sort.order = "asc";
      } else if (order === "descending") {
        this.sort.order = "desc";
      } else {
        this.sort.order = "";
      }
      this.sort.prop = prop;
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
    // 打开弹窗
    async openDialog(id, flag = false) {
      this.dialogVisible = true;
      this.loading = true;
      const [err, res] = await this.$http.post("complain/refund", {
        id,
        trade_no: this.trade_no_list,
        is_compel: flag,
      });
      if (flag) {
        res.list = [];
      }
      if (err) {
        this.$message.error("系统错误，请联系项目中台");
        this.dialogVisible = false;
        this.loading = false;
        this.errArr = [];
        this.trade_no_list = [];
        return;
      }
      this.loading = false;
      this.errArr = res.list;
      if (!res.list.length) {
        setTimeout(() => {
          this.dialogVisible = false;
          this.trade_no_list = [];
          // this.initFrom();
          // this.getReport();
          this.onSubmit();
          this.$refs.multipleTable.$refs.table.clearSelection();
        }, 2500);
      }
    },
    // 批量退款
    allBack() {
      if (this.tableIds.length == 0) {
        this.$message.error("请勾选投诉单号");
        return;
      }
      if (this.tableIds.length >= 100) {
        this.$message.error("批量处理投诉单号不可超过100条");
        return;
      }
      if (
        this.selectAll.indexOf(1) !== -1 ||
        this.selectAll.indexOf(7) !== -1
      ) {
        let flag = false;
        this.tableRow.forEach((item) => {
          if (item.trade_no.length > 1) {
            flag = true;
          }
        });
        if (flag) {
          this.$message.error("只可选择包含一条平台交易单的投诉单号");
          return;
        }
        this.openDialog(this.tableIds);
      } else {
        this.$message.error("只可选择待处理与客服处理中的投诉订单");
        return;
      }
    },
    // 强制完结
    forceOver() {
      // 是否允许多选
      if (this.tableIds.length == 0) {
        this.$message.error("请勾选需强制完结的单号");
        return;
      }
      if (this.tableIds.length >= 100) {
        this.$message.error("强制完结投诉单号不可超过100条");
        return;
      }
      if (
        this.selectAll.indexOf(4) !== -1 ||
        this.selectAll.indexOf(3) !== -1 ||
        this.selectAll.indexOf(5) !== -1
      ) {
        this.$message.error("所选项已完结，请重新选择");
        return;
      }
      this.openDialog(this.tableIds, true);
    },
    // 复制
    copyList() {
      const textarea = document.createElement("textarea");
      let str = this.errArr.join("\r\n");
      textarea.value = str;
      document.body.appendChild(textarea); // 添加临时实例
      textarea.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(textarea); // 删除临时实例
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    // 关闭弹窗
    downDia() {
      this.errArr = [];
      this.trade_no_list = [];
      this.$refs.myTable.clearSelection();
      this.onSubmit();
    },
    // 操作表格多选
    handleSelectionChange(row) {
      let trade_no_list = row.map((item) => {
        return item.trade_no;
      });
      this.trade_no_list = trade_no_list;
    },
    // 显示列表表格的回调函数
    showPopover(id) {
      this.$nextTick(() => {
        document.getElementById(
          this.$refs["popover-" + id].$refs.popper.id
        ).style.display = "none";
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top-box {
  margin-bottom: 20px;

  .btn {
    margin-top: 20px;
  }
}

.component_title2 {
  background: #fff;
  padding: 1px 0 10px 15px;
  font-weight: bold;
}

.component_title {
  background: #fff;
  padding: 20px 0 10px 15px;
  font-weight: bold;
}

.font14 {
  font-size: 14px;
}

.Tab_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  button {
    margin-right: 20px;
  }

  .left_box {
    line-height: 40px;
    // width: 1000px;
    display: flex;

    .btns {
      margin-left: 20px;
    }
  }
}

.my-select {
  height: 40px;
}

.check-all {
  padding: 0 20px;
  text-align: right;
}

/deep/ .err_tit_dialog .el-dialog__title {
  color: rgb(255, 88, 88);
}

/deep/ .sur_tit_dialog .el-dialog__title {
  color: rgb(35, 184, 67);
}

/deep/.el-dialog {
  border-radius: 12px;
}

.dialog_box {
  display: flex;
  justify-content: center;

  .flex_j_content {
    width: 100%;
  }

  .imgClass {
    width: 100px;
  }

  .btn_box {
    margin-top: 10px;
  }

  .err_title {
    font-size: 12px;
    color: rgb(189, 30, 30);
  }

  .err_srcoll_box {
    height: 200px;
    margin-top: 10px;

    div {
      font-size: 16px;
      padding: 1px 0;
      font-weight: 700;
    }
  }

  .btn_list {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }

  /deep/.el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /deep/.el-icon-loading:before {
    font-size: 50px;
  }

  /deep/.el-loading-spinner {
    top: 30%;
  }
}

/deep/ .el-table {
  .cell {
    white-space: nowrap;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
  }
}
</style>
